import $ from 'jquery';
import { closeModal } from '@/function/function.js';
import ModalCreerPatient from "@/components/creer-patient-modal";

import store_patient from "@/store/mods/clinique/patients"

export default {
    name: "choice-patient",
    components: {
        ModalCreerPatient
    },
    props: ["type"],
    data() {
        return {
            show_state: 0,
            assur_selected: '',
            filter: "",
            perPage: -1,
            currentPage: 1,
            total_pages: 0,
            fields: [
                { key: 'patient', label: 'Patients' }, { key: 'sexe', label: 'Sexes' }, { key: 'age', label: 'Âge' },
                { key: 'telephone', label: 'Téléphones' }, 'assurance', { key: 'type_consultation', label: 'Consultations en cours' }
            ],
            url_to_go: "",

            patients: [],
            patient_loading: true,
            patient_empty: false,
            search_filter: {
                with_consultation: true
            }
        };
    },

    watch: {
        filter() {
            if (this.filter == '') {
                this.search_filter.search_term = ''
                this.refreshListePatient()
            }
        }  
    },

    computed: {
        
    },

    mounted() {
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);

        this.$store.commit("SET_PATIENT", {});

        this.refreshListePatient()

        //url to go after selection
        let action_selected = this.$store.getters["typeActionSelected"];
        if (action_selected == "bon_consultation") {
            this.url_to_go = { name: 'Bon consultation' }
        } else if (action_selected == "bon_medical") {
            this.url_to_go = { name: 'Bon medical' }
        }
    },

    methods: {
        refreshListePatient() {
            this.patient_loading = true

            store_patient.getListeAllPatient(this.search_filter).then((patients) => {
                this.patients = patients.data
                this.total_pages = patients.last_page
                
                if (this.patients.length == 0) {
                    this.patient_empty = true
                } else {
                    this.patient_empty = false
                }

                this.patient_loading = false
            })
        },

        
        // recupérer de l'élément enfant, le nouveau patient créé
        onChildPassNewPatient(value) {
            this.filter = value.nom + " " + value.prenoms;
        },

        choosePatient: function(patient_data) {

            const selected_patient = {
                id: parseInt(patient_data.patient_id),
                nom: patient_data.patient_nom,
                nom_patient: patient_data.patient_nom,
                prenoms: "",
                sexe: patient_data.sexe,
                telephone_mobile: patient_data.patient_telephone,
                age: patient_data.age,
                num_dossier: patient_data.patient_code
            }
            this.$store.commit("SET_CHOSEN_PATIENT", selected_patient);

            this.$router.push(this.url_to_go)
        },
        /**
         * Show select options in dropdown
         * @param {int} j_state 
         * @param {string} selector 
         */
        openSelectOption(j_state, selector) {

            if (this.show_state == 0) {
                $('.' + selector).fadeIn();
                $('#' + selector).removeClass('animate__fadeOutTop');
                $('#' + selector).addClass('animate__fadeInTop');
            } else {
                $('#' + selector).removeClass('animate__fadeInTop');
                $('#' + selector).addClass('animate__fadeOutTop');
                $('.' + selector).fadeOut();
            }

            if (j_state == 0) {
                j_state = 1;
            } else {
                j_state = 0;
            }
            this.show_state = j_state;
        },

        /**
         * Select option in dropdown
         * @param {string} selected_value 
         * @param {string} selector 
         * @param {string} model_selector 
         */
        selectOption(selected_value, selected_id, selector, model_selector) {
            switch (model_selector) {
                case 'assur':
                    this.assur_selected = selected_value;
                    this.assureur = selected_id
                    break;
            }

            $('#' + selector).removeClass('animate__fadeInTop');
            $('#' + selector).addClass('animate__fadeOutTop');
            $('.' + selector).fadeOut();

            this.show_state = 0;
        },

        /**
         * Close Modal
         * @param {*} selector 
         */
        closeModal(selector) {
            closeModal.closeModal(selector);
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.search_filter.page = this.currentPage
                this.refreshListePatient()
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.search_filter.page = this.currentPage
                this.refreshListePatient()
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.search_filter.page = this.currentPage
                this.refreshListePatient()
            }
        },

        searchPatient() {
            this.search_filter.search_term = this.filter
            this.refreshListePatient()
        }
    },
};